import {Model} from '@ab/components';
import queryParams from '../queries/main.m.q';
import protocol from '../../../protocol.sync';
import parsers from '../parsers/main.m.p';

export default class extends Model {
    static protocol = protocol;

    static queryParams = queryParams;

    static parsers = parsers;

    isTeacherSession() {
        return this.get('session_type') === 'teacher';
    }
}
